export default "__VITE_ASSET__uKcPyVEr__"